import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { concat as _concat, uniq as _uniq, compact as _compact } from 'lodash';
import langs from 'langs';

import FormRadio from 'components/forms/FormRadio';

class FormLanguageSelector extends React.Component {
  getLangs = () => {
    const { user, languages, projectConfig, whiteLabel, myWhiteLabelProject } = this.props;

    let langsList = _concat(user.project_lang.project_languages, projectConfig.data.languages);
    if (languages) {
      langsList = _concat(langsList, languages);
    }

    if (whiteLabel.data) {
      langsList = _concat(langsList, whiteLabel.data.languages);
    }

    if (myWhiteLabelProject.data.count) {
      for (let i = 0; i < myWhiteLabelProject.data.list.length; i++) {
        langsList = _concat(langsList, myWhiteLabelProject.data.list[i].languages);
      }
    }

    return _compact(_uniq(langsList));
  };

  render() {
    const {
      intl: { messages },
      name,
      value,
      onChange,
    } = this.props;

    return (
      <FormRadio
        label={messages.language}
        options={this.getLangs().map(language => {
          return {
            label: langs.where('1', language).local,
            value: language,
          };
        })}
        onChange={onChange}
        value={value}
        name={name}
      />
    );
  }
}
FormLanguageSelector.defaultProps = {
  name: 'language',
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    projectConfig: state.data.projectConfig,
    whiteLabel: state.data.whiteLabel,
    myWhiteLabelProject: state.list.myWhiteLabelProject,
  };
};

export default injectIntl(connect(mapStateToProps)(FormLanguageSelector));
